import { EServiceCategory } from 'src/app/enums';
import { CommonData } from './common-data.model';
import { ServiceCategory } from './service-category.model';

export class ServiceType extends CommonData {
    CategoryId: number | EServiceCategory;
    Category: ServiceCategory;
}
